// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xuWEJ","clinicsSelect":"styles_clinicsSelect__2nGLH"};